export const SUBSCRIBE_MEMBER_CHECKOUT_REQUEST = 'SUBSCRIBE:MEMBER_CHECKOUT_REQUEST';
export const SUBSCRIBE_MEMBER_CHECKOUT_SUCCESS = 'SUBSCRIBE:MEMBER_CHECKOUT_SUCCESS';
export const SUBSCRIBE_MEMBER_CHECKOUT_FAILURE = 'SUBSCRIBE:MEMBER_CHECKOUT_FAILURE';

export const SUBSCRIBE_MEMBER_CANCEL_REQUEST = 'SUBSCRIBE:MEMBER_CANCEL_REQUEST';
export const SUBSCRIBE_MEMBER_CANCEL_SUCCESS = 'SUBSCRIBE:MEMBER_CANCEL_SUCCESS';
export const SUBSCRIBE_MEMBER_CANCEL_FAILURE = 'SUBSCRIBE:MEMBER_CANCEL_FAILURE';

export const SUBSCRIBE_MEMBER_RENEW_REQUEST = 'SUBSCRIBE:MEMBER_RENEW_REQUEST';
export const SUBSCRIBE_MEMBER_RENEW_SUCCESS = 'SUBSCRIBE:MEMBER_RENEW_SUCCESS';
export const SUBSCRIBE_MEMBER_RENEW_FAILURE = 'SUBSCRIBE:MEMBER_RENEW_FAILURE';

export const SUBSCRIBE_MEMBER_CLEAR_ERROR = 'SUBSCRIBE:MEMBER_CLEAR_ERROR';

export const SUBSCRIBE_CLUB_RENEW_REQUEST = 'SUBSCRIBE:CLUB_RENEW_REQUEST';
export const SUBSCRIBE_CLUB_RENEW_SUCCESS = 'SUBSCRIBE:CLUB_RENEW_SUCCESS';
export const SUBSCRIBE_CLUB_RENEW_FAILURE = 'SUBSCRIBE:CLUB_RENEW_FAILURE';

export const SUBSCRIBE_CLUB_CHECKOUT_REQUEST = 'SUBSCRIBE:CLUB_CHECKOUT_REQUEST';
export const SUBSCRIBE_CLUB_CHECKOUT_SUCCESS = 'SUBSCRIBE:CLUB_CHECKOUT_SUCCESS';
export const SUBSCRIBE_CLUB_CHECKOUT_FAILURE = 'SUBSCRIBE:CLUB_CHECKOUT_FAILURE';

export const SUBSCRIBE_UPDATE_PAYMENT_REQUEST = 'SUBSCRIBE:UPDATE_PAYMENT_REQUEST';
export const SUBSCRIBE_UPDATE_PAYMENT_SUCCESS = 'SUBSCRIBE:UPDATE_PAYMENT_SUCCESS';
export const SUBSCRIBE_UPDATE_PAYMENT_FAILURE = 'SUBSCRIBE:UPDATE_PAYMENT_FAILURE';

export const SUBSCRIBE_SUBSCRIPTION_INFO_REQUEST = 'SUBSCRIBE:SUBSCRIPTION_INFO_REQUEST';
export const SUBSCRIBE_SUBSCRIPTION_INFO_SUCCESS = 'SUBSCRIBE:SUBSCRIPTION_INFO_SUCCESS';
export const SUBSCRIBE_SUBSCRIPTION_INFO_FAILURE = 'SUBSCRIBE:SUBSCRIPTION_INFO_FAILURE';

export const SUBSCRIBE_INVOICE_PRINT = 'SUBSCRIBE_INVOICE_PRINT';
